import FormValidation from "../../Validation/FormValidation";

const DateInput = {

    bind(form) {
        this.input = '.input.date input[type="text"]';
        form.find(this.input).on('change', (evt) => {
            FormValidation.setValid($(evt.currentTarget), this.isValid($(evt.currentTarget)));
        });

        form.find(this.input).on('click', (evt) => {
            evt.preventDefault();
        })

        const today = new Date()
        const tomorrow = new Date(today)
        tomorrow.setDate(tomorrow.getDate() + 1)

        $(this.input).datepicker({
            dateFormat: "dd.mm.yy",
            minDate: new Date(),
            beforeShowDay: (date) => {
                const day = date.getDay();
                const enabled = (!(day === 0 || day === 6))
                return [enabled, "", ""];
            }
        });
    },

    check(form) {
        let ok = true;
        form.find(this.input).each((i, el) => {
            ok &= this.isValid($(el));
            FormValidation.setValid($(el), this.isValid($(el)), true);
        })
        return ok;
    },

    isValid(input) {
        const isRequired = input.closest('.input').is('.required');

        if (isRequired) return input.val().length === 10
        else return true;

    },
}

export default DateInput;
